// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2lA4v","Brand":"SideDrawer_Brand__12Tsh","Open":"SideDrawer_Open__380AU","Close":"SideDrawer_Close__3bbZn"};